import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../../lib/firebase';

export const MAX_QUOTATION_FILE_MB = 20;

/** Ajánlathoz tartozó fájl feltöltése: quotations/{org}/files/{idő}_{név}. A tokenes letöltési URL a nyilvános linken is működik. */
export async function uploadQuotationFile(file: File, orgId: string) {
  if (file.size > MAX_QUOTATION_FILE_MB * 1024 * 1024) throw new Error(`A fájl legfeljebb ${MAX_QUOTATION_FILE_MB} MB lehet: ${file.name}`);
  const safe = file.name.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9._-]+/g, '_').slice(-120);
  const path = `quotations/${orgId || 'common'}/files/${Date.now()}_${safe}`;
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type || 'application/octet-stream' });
  const url = await getDownloadURL(r);
  return { url, path, name: file.name, size: file.size, uploadedAt: new Date().toISOString() };
}

export async function deleteQuotationFile(path?: string) {
  if (!path) return;
  try { await deleteObject(ref(storage, path)); } catch { /* már nincs meg – nem gond */ }
}

export const fmtSize = (n?: number) => (!n ? '' : n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
